import React from 'react';
import classNames from 'classnames';
import { getCurrencySymbol } from '../utils';
import { getProductFromOrderType } from '../../helpers/product.helpers';
import styles from './ProcessRefund.module.scss';
import { getFullBundleRefundAmount } from './refundOptions.helpers';
import { TOrderRefundDetails } from '../../types/bundle.types';

interface RefundDetailsProps {
  currency: string;
  orderRefundDetails: Array<TOrderRefundDetails>;
}
const RefundDetails = (props: RefundDetailsProps) => {
  const { orderRefundDetails, currency } = props;

  const getAmountToDisplay = (amount: number): string => {
    return `${getCurrencySymbol(currency.toUpperCase())}${amount.toFixed(2)}`;
  };

  return (
    <div className={styles.refundDetailsWrapper}>
      <div
        className={classNames(
          styles.refundDetailsRow,
          styles.refundDetailsHeader
        )}
      >
        <div>Full bundle refund</div>
        <div>
          {getAmountToDisplay(getFullBundleRefundAmount(orderRefundDetails))}
        </div>
      </div>
      {orderRefundDetails.map((order: TOrderRefundDetails) => (
        <div key={order.orderId} className={styles.refundDetailsRow}>
          <div>{getProductFromOrderType(order.orderType)} refund</div>
          <div>{getAmountToDisplay(order.refundableAmount)}</div>
        </div>
      ))}
    </div>
  );
};

export default RefundDetails;
